import React, { useRef, useState, useEffect, memo, useCallback } from 'react';
import ReactPlayer from 'react-player';
import dayjs from 'dayjs';
import './css/videoplayer-v2.scss';
import { useDispatch, useSelector } from 'react-redux';
import { isMacOs, isMobile, useMobileOrientation } from 'react-device-detect';
import queryString from 'query-string';
import * as bannerUtils from '../../banner/utils';
import { bannerLocalConstant, getCurrentTime, openNewTab } from '../../banner/utils';
import { downloadFromUrl, getClientDeviceDetails, getLocalStorage } from '../../../common/common';
import {
  updateReportData,
  addBannerClickReport,
  updateCurrentQueue,
  addBannerConsentClickReport
} from '../../../Store/actions';
import { sendVideoAnalytics } from '../../../Store/actions/common.actions';
import { useLocation } from 'react-router';
import SkipButton from './components/SkipButton';
import useRedirect from '../../customHooks/useRedirect';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
import VideoOverlayAds from '../../banner/VideoOverlayAds';
import InVideoQuiz from './components/InVideoQuiz';
import { InVideoBannerCard } from '../../banner';

import { useNavigate } from 'react-router-dom';
// import './css/player.css';

import Title from './components/Title';
import Controls from './components/Controls';
import screenful from './utils/screenful';

import CtaCard from './components/CtaCard';
import VideoAdsWorker from './components/VideoAdsWorker';
import InteractiveSpq from './components/InteractiveSpq';

import { useInteractiveSPQ } from '../../../Queries/QueryHooks/interactiveSPQ.hook';
import { toast } from 'react-toastify';
import { cleanSpqQueueItem, setSpqQueueItem } from '../../../Store/actions/videoPlayer.action';
import ConsentModal from '../../banner/ConsentModal';

let tracking_data = {
  content_id: '',
  content_type: '',
  start_time: '',
  end_time: '',
  video_duration: '',
  seekbar_change: [],
  progress: [],
  max_view_duration: ''
};

let progressData = {
  step: []
};

let step_counter = 0;
const VIDEO_TYPE_ADS = 'ads';
const VIDEO_TYPE_MAIN = 'content';
const VIDEO_TYPE_SPQ = 'spq';
let playinline = true;
let position = bannerLocalConstant.BANNER_POSITION_VIDEO;

const TARGET_TYPE_FLOATING = 'Floating';
const TARGET_TYPE_FILLER = 'Filler';
const TARGET_TYPE_FIXED = 'Fixed';
const _TARGET_BLANK = '_blank';
const _TARGET_SELF = '_self';
const _TARGET_DOWNLOAD = 'download';
const BANNER_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

let progress_delay = 10;
let temp_creative_id = 0;

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  // console.log('returning from previous' + ref.current);
  return ref.current;
};

const useCompare = (val) => {
  const prevVal = usePrevious(val);
  // console.log('return from useCompare' + prevVal !== val);
  return prevVal !== val;
};

const format = (seconds) => {
  if (isNaN(seconds)) {
    return `00:00`;
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, '0');
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, '0')}:${ss}`;
  }
  return `${mm}:${ss}`;
};

const tempSpqData = [
  {
    spq_id: '1376',
    spq_start_time: '20',
    isSkipButton: 'false',
    isCompleted: 'false'
  },
  {
    spq_id: '1373',
    spq_start_time: '30',
    isSkipButton: 'true'
  }
];

let bufferCounter = 5;
let count = 5;
let buffer_counter = 0;
let currentTime = 0;
let getduration = 0;
let getSecondsLoaded = 0;
let elapsedTime = 0;
let totalDuration = 0;
let videoDuration = 0;
let handlerCheckCounter = 0;
const ReactVideoAdsPlayer = ({
  file = '',
  title = '',
  deeplink = '',
  playlist = [],
  page_name = '',
  thumbnail = '',
  videoStartTime = '',
  page_id = 0,
  live = false,
  ...rest
}) => {
  const isCommentFocused = useSelector((state) => state.common.is_comment_focused);
  const userDetails = () => (getLocalStorage('user', false) ? getLocalStorage('user', {}) : {});
  const PROGRESS_INTERVAL = 1000;
  const DATA_DESIMAL_POINT = 2;
  const timeFormat = 'YYYY-MM-DD HH:mm:ss';

  const spqIndex = useRef(0);
  const _playing_item_ref = useRef([]);
  const _playing_index_ref = useRef(-1);

  const controlsRef = useRef(null);
  const playerRef = useRef(null);

  const playerContainerRef = useRef(null);
  const playerAndControl = useRef(null);

  const [platform_name, set_platform_name] = useState(bannerUtils.getPlatForm());
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const { isLandscape } = useMobileOrientation();
  const [timeDisplayFormat, setTimeDisplayFormat] = React.useState('normal');
  const [videoUrl, setvideoUrl] = useState(file ?? '');
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isMobileSettingsOpen, setIsMobileSettingsOpen] = useState(false);
  const [videoType, setVideoType] = useState(VIDEO_TYPE_MAIN);

  const [playerLoadedFirstTime, setPlayerLoadedFirstTime] = useState(false);
  const [videoState, setVideoState] = useState({
    pip: false,
    playing: true,
    controls: false,
    light: false,
    muted: true,
    played: 0,
    duration: 0,
    playbackRate: 1,
    volume: 1,
    loop: false,
    isBuffering: false,
    isLive: live,
    seeking: false,
    fullscreen: false,
    isSkipButton: false,
    isError: false,
    controlVisibility: false
  });

  let content_ads_data = useSelector((state) => state.banner.content_banner_data);
  let content_fetch_status = useSelector((state) => state.banner.content_data_get);
  let global_ads_data = useSelector((state) => state.banner.banner_data);
  let banner_exclution_list = useSelector((state) => state.banner.banner_exclution_list);
  let banner_settings_data = useSelector((state) => state.banner.banner_settings);
  let banner_queue_data = useSelector((state) => state.banner.current_banner_queue);
  let spqData = useSelector((state) => state.videoPlayer.spqItem);

  const {
    playing,
    controls,
    light,
    muted,
    loop,
    playbackRate,
    pip,
    played,
    seeking,
    volume,
    fullscreen,
    duration,
    isBuffering,
    isSkipButton,
    isLive,
    isError,
    controlVisibility
  } = videoState;

  const setVideoConatinerSize = () => {
    if (playerContainerRef.current) {
      const videoDivWidth = playerContainerRef.current ? playerContainerRef.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
      // //console.log('aspect size is' + aspectWidth);
    }
  };
  const [openedSetting, setOpenedSetting] = useState('');
  const [ads_banner_main_data, set_ads_banner_main_data] = useState([]);
  const [content_id, set_content_id] = useState(page_id ? page_id : 0);
  const [adsIndex, setAdsIndex] = useState(-1);
  const [showSkipBtn, setShowSkipBtn] = useState(false);
  const [previous_video_time, set_previous_video_time] = useState(0);
  const [isEligbleForAds, setIsEligbleForAds] = useState(true);
  const [isMAxViewOver, setIsMaxViewOver] = useState(false);
  const [lastAdsViewedTimestamp, setLastAdsViewedTimestamp] = useState('');
  const [videoAdsShowCount, setVideoAdsShowCount] = useState(0);
  const [banner_play_data, set_banner_play_data] = useState([]);
  const [banner_position, set_banner_position] = useState(position);
  const [separate_data, set_separate_data] = useState({});
  const [isSpqShown, setIsSpqShown] = useState(false);
  const [isSkipable, setIsSkipable] = useState(false);

  const [video_ads_setting, set_video_ads_setting] = useState('');
  const [banner_user, set_banner_user] = useState(getLocalStorage('user', '{}')?.user_master_id);
  const [playingIndex, setPlayingIndex] = useState(0);

  const [adsInQueue, setAdsInQueue] = useState(false);
  const [countdownStart, setCountdownStart] = useState(false);
  const [allSpqData, setAllSpqData] = useState([]);
  const [spqNotAllowed, setSpqNotAllowed] = useState(false);
  const [is_consent_modal, setIsConsentModal] = useState(false);
  const [consent_text, setConsentText] = useState('');
  const toggleConsentModal = (payload) => setIsConsentModal(payload);
  const videoAnalyticsRef = useRef(null);
  const prevCountRef = useRef();
  const { redirectTo } = useRedirect();
  const dispatch = useDispatch();
  const hasLastTimestampChanged = useCompare(lastAdsViewedTimestamp);
  const { search } = useLocation();
  const nav = useNavigate();

  const onSuccess = (data) => {
    if (data && data?.length > 0) {
      let filterData = data
        .sort((a, b) => a.duration - b.duration)
        .filter((x) => x.user_survey_status == 0);
      setAllSpqData(filterData);
    }
  };
  const onError = () => { };
  const { data: spqVideoList, isLoading } = useInteractiveSPQ(
    page_name,
    content_id,
    onSuccess,
    onError
  );
  const { id } = queryString.parse(search);
  const videoDetailsParent = useRef();

  const setBannerSettings = (_banner_settings_data, _position) => {
    let temp_banner_settings_data = _banner_settings_data;

    let module_settings = filterJsonByPosition(temp_banner_settings_data, _position);
    console.group('banner settings' + _position);
    // console.log('module settings inside out:' + JSON.stringify(module_settings) + '::' + _position);
    module_settings?.length > 0 && set_video_ads_setting(module_settings[0]);
    console.groupEnd('banner settings' + _position);
  };

  const filterJsonByPosition = (data = [], matching_value = '') => {
    return data.filter((x) => {
      return x?.position?.toLowerCase() == matching_value?.toLowerCase() && x?.status === '3';
    });
  };

  const btnPressHandler = (event) => {
    console.log('in btn press', event.key, event.keyCode);

    switch (event.keyCode) {
      case 32: //space bar
        handlePlayPause();
        event.preventDefault();
        break;
      case 37: //left arrow
        handleRewind();
        break;
      case 39: //right arrow
        handleFastForward();
        break;
      case 27: //esc
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    console.log('content id changed', page_id);
    setvideoUrl('');
    set_ads_banner_main_data([]);
    setAdsIndex(-1);
    setVideoType(VIDEO_TYPE_MAIN);
    setShowSkipBtn(false);
    set_previous_video_time(0);
    setIsEligbleForAds(true);
    setIsMaxViewOver(false);
    setLastAdsViewedTimestamp('');
    setVideoAdsShowCount(0);
    set_banner_play_data([]);
    set_separate_data({});
    setIsSpqShown(false);
    setIsSkipable(false);
    set_video_ads_setting('');
    setPlayingIndex(0);
    setAdsInQueue(false);
    setAllSpqData([]);
    setSpqNotAllowed(false);
    dispatch(cleanSpqQueueItem());
    return () => {
      setvideoUrl('');
      set_ads_banner_main_data([]);
      setAdsIndex(-1);
      setVideoType(VIDEO_TYPE_MAIN);
      setShowSkipBtn(false);
      set_previous_video_time(0);
      setIsEligbleForAds(true);
      setIsMaxViewOver(false);
      setLastAdsViewedTimestamp('');
      setVideoAdsShowCount(0);
      set_banner_play_data([]);
      set_separate_data({});
      setIsSpqShown(false);
      setIsSkipable(false);
      set_video_ads_setting('');
      setPlayingIndex(0);
      setAdsInQueue(false);
      setAllSpqData([]);
      setSpqNotAllowed(false);
      dispatch(cleanSpqQueueItem());
    };
  }, [page_id]);
  const spqHandler = (currentTime, spq_data, duration, queueParams) => {
    // handlerCheckCounter += 1;
    // if (handlerCheckCounter <= 5) {
    //   return false;
    // }
    // handlerCheckCounter = 0;

    let spqQueueItem = '';
    spqQueueItem = spq_data?.length > 0 ? spq_data[spqIndex.current] : {};
    // console.group('@@spq Handler');
    // console.log(
    //   'spq data',
    //   duration,
    //   currentTime,
    //   '\n',
    //   spq_data,
    //   '\n',
    //   spqIndex.current,
    //   '\n',
    //   spqQueueItem
    // );
    // console.groupEnd('@@spq Handler');

    if (
      currentTime >= 0 &&
      spqQueueItem?.duration >= 0 &&
      Math.ceil(currentTime) >= Math.ceil(spqQueueItem?.duration)
    ) {
      // console.log('Spq handler in ', spqQueueItem);

      if (spqQueueItem && !queueParams) {
        dispatch(setSpqQueueItem(spqQueueItem));
      }
    } else {
      // console.log('spq item else', spqQueueItem);
    }
    // console.groupEnd('skip btn logic');
  };

  useEffect(() => {
    // console.log('spq handler-----------', '\n', isLoading, videoType);
    if (videoType != VIDEO_TYPE_MAIN) {
      // console.log('spq1-----------||||||||||||||||||||||||');
      return false;
    } else if (currentTime <= 0 || duration <= 0 || allSpqData?.length <= 0) {
      // console.log('spq2-----------||||||||||||||||||||||||');
      return false;
    } else if (videoType == VIDEO_TYPE_MAIN) {
      console.log('spq3-----------||||||||||||||||||||||||');
      spqHandler(currentTime, allSpqData, duration, spqData);
    } else {
      console.log('spq handler not needed');
    }
  }, [page_id, duration, currentTime, allSpqData, videoType, spqData]);

  useEffect(() => {
    // console.log('CAN_PLAYABLE', ReactPlayer.canPlay(file));
    setvideoUrl(file);
    return () => {
      setvideoUrl('');
    };
  }, [file]);

  useEffect(() => {
    // if (live) {
    //   setIsEligbleForAds(false);
    // } else {
    //   setIsEligbleForAds(true);
    // }
    setVideoState((prev) => {
      return { ...prev, isLive: live };
    });
    return () => {
      setVideoState((prev) => {
        return { ...prev, isLive: false };
      });
    };
  }, [live]);

  useEffect(() => {
    if (videoAnalyticsRef) {
      videoAnalyticsRef.current = tracking_data;
    }
  }, [tracking_data]);

  // useEffect(() => {
  //   if (isError) {
  //     setVideoState((prev) => {
  //       return { ...prev, playing: false };
  //     });
  //   }
  // }, [isError]);

  useEffect(() => {
    !isCommentFocused && document.addEventListener('keydown', btnPressHandler, false);
    return () => {
      document.removeEventListener('keydown', btnPressHandler, false);
    };
  }, [btnPressHandler, isCommentFocused]);

  const exitFullscreenHandler = (e) => {
    setVideoState((prev) => {
      return { ...prev, fullscreen: screenful.isFullscreen };
    });

    // e.preventDefault();

    // if (screenful?.isInFullScreen) {
    //   console.log('SCREENFUL_FUNCTION_IF', videoState, fullscreen, screenful?.isInFullScreen);
    //   setVideoState((prev) => {
    //     return { ...prev, fullscreen: false };
    //   });
    // } else {
    //   setVideoState({ ...videoState, fullscreen: true });
    //   console.log('in btn press else', videoState, screenful?.isInFullScreen, fullscreen);
    // }
    // if (type == 'exit') {
    //   return false;
    // } else {
    //   setVideoState({ ...videoState, fullscreen: false });
    // }
  };

  const onVisibilityChange = () => { };
  useEffect(() => {
    let visibilityChange = null;
    if (typeof document.hidden !== 'undefined') {
      visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange';
    }
    window.addEventListener(visibilityChange, onVisibilityChange);
    window.addEventListener('fullscreenchange', exitFullscreenHandler);
    tracking_data.content_id = page_id ?? 0;
    tracking_data.content_type = page_name ?? 0;
    setPlayerLoadedFirstTime(true);
    return () => {
      let temp_tracking_data = videoAnalyticsRef.current;
      if (temp_tracking_data) {
        temp_tracking_data.play_time = prevCountRef.current;
        temp_tracking_data.end_time = getCurrentTime();
        console.log('end time' + temp_tracking_data.end_time);
        sendVideoAnalytics(temp_tracking_data);
      }
      window.removeEventListener(visibilityChange, onVisibilityChange);
      window.removeEventListener('fullscreenchange', exitFullscreenHandler);
      dispatch(cleanSpqQueueItem());
      setPlayerLoadedFirstTime(false);
    };
  }, []);

  useEffect(() => {
    //console.log('banner settings changed ' + banner_settings_data?.length);
    if (banner_settings_data?.length > 0) {
      setBannerSettings(banner_settings_data, position);
    }
  }, [banner_settings_data, position]);

  useEffect(() => {
    if (content_fetch_status && content_ads_data?.video_banner_data?.length > 0 && adsIndex <= 0) {
      //console.log('content fetched');
      setAdsIndex(0);
      set_ads_banner_main_data(content_ads_data?.video_banner_data);
      dispatch(
        updateCurrentQueue({
          ...banner_queue_data,
          video_banner_data: content_ads_data?.video_banner_data[0]
        })
      );
    }
  }, [ads_banner_main_data, adsIndex]);

  useEffect(() => {
    if (
      content_id &&
      content_id != 0 &&
      banner_exclution_list?.length > 0 &&
      bannerUtils._isContains(banner_exclution_list, 'type', page_name)
    ) {
      let exclutionList = bannerUtils.filterExclutionListByType(banner_exclution_list, page_name);

      console.group(`checking exclutionList`);
      //console.log(JSON.stringify(exclutionList));
      console.groupEnd(`checking exclutionList`);

      if (exclutionList?.length > 0) {
        //console.log('exclution length >0');
        let { ids } = exclutionList[0];

        //console.log('ids:::' + ids.split(','));
        let excludedIds = ids ? ids.split(',') : [];

        if (excludedIds.includes(content_id)) {
          //console.log('exclution id  avalable');
          setIsEligbleForAds(false);
        } else {
          //console.log('exclution id not available');
          setIsEligbleForAds(true);
        }
      } else {
        //console.log('exclution not length >0');
        setIsEligbleForAds(true);
      }
    } else {
      //console.log('exclution else');
      setIsEligbleForAds(true);
    }
    return () => { };
  }, [banner_exclution_list]);

  // global and content banner data observer effect
  useEffect(() => {
    bannerUtils.log('bannner global effect');
    if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      content_ads_data &&
      typeof content_ads_data == 'object'
    ) {
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_VIDEO:
          if (content_ads_data.video_banner_data) {
            set_banner_play_data([...new Set([...content_ads_data.video_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no banner data found ');
          break;
      }
      // break data_extract_condition;
    } else if (
      (!content_id || content_id == 0) &&
      !content_fetch_status &&
      !content_ads_data &&
      global_ads_data &&
      typeof global_ads_data == 'object'
    ) {
      ////console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_VIDEO:
          if (global_ads_data.video_banner_data) {
            set_banner_play_data([...new Set([...global_ads_data.video_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no banner data found ');
          break;
      }
    } else if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      !content_ads_data &&
      global_ads_data &&
      typeof global_ads_data == 'object'
    ) {
      // ////console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_VIDEO:
          if (global_ads_data.video_banner_data) {
            set_banner_play_data([...new Set([...global_ads_data.video_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no global banner data found ');
          break;
      }
    } else {
      // set_banner_setting("0x0")
      // ////console.log('--------------------global not available ');
    }
  }, [global_ads_data, content_ads_data, content_fetch_status]);

  // banner play data observer
  useEffect(() => {
    // ////console.log('banner play data ' + banner_play_data?.length);
    if (banner_play_data?.length > 0) {
      filterBannerData();
    }
  }, [banner_play_data]);

  useEffect(() => {
    if (handlerCheckCounter <= 5 || adsInQueue) {
      return false;
    }
    if (lastAdsViewedTimestamp && video_ads_setting.time_difference_between_ads) {
      let timeDiffFromLastVideoPlay = getTimeDifference(lastAdsViewedTimestamp);
      console.log('time difference between ads', timeDiffFromLastVideoPlay);
      if (
        timeDiffFromLastVideoPlay >= video_ads_setting.time_difference_between_ads &&
        videoType == VIDEO_TYPE_MAIN &&
        !isEligbleForAds &&
        !isMAxViewOver &&
        !hasLastTimestampChanged
      ) {
        // console.log('::::::::::::::::::::::::::::::::::::::::::::if' + hasLastTimestampChanged);
        if (!isEligbleForAds) {
          setIsEligbleForAds(true);
        }
      } else {
        // console.log('ads eligibility:else' + hasLastTimestampChanged);
        if (isEligbleForAds) {
          setIsEligbleForAds(false);
        }
      }
    }
    return () => {
      // setIsEligbleForAds(true);
    };
  }, [
    currentTime,
    lastAdsViewedTimestamp,
    hasLastTimestampChanged,
    isEligbleForAds,
    video_ads_setting,
    isMAxViewOver,
    videoType,
    adsInQueue
  ]);

  useEffect(() => {
    if (
      videoType == VIDEO_TYPE_MAIN &&
      !isLive &&
      isEligbleForAds &&
      !isSpqShown &&
      currentTime >= 0 &&
      adsIndex >= 0 &&
      ads_banner_main_data?.length > 0 &&
      adsIndex < ads_banner_main_data?.length &&
      !isMAxViewOver &&
      !hasLastTimestampChanged &&
      video_ads_setting
    ) {
      adsHandler(currentTime, ads_banner_main_data, adsIndex, duration);
    } else {
      return false;
    }
  }, [
    currentTime,
    ads_banner_main_data,
    adsIndex,
    videoType,
    duration,
    isEligbleForAds,
    lastAdsViewedTimestamp,
    hasLastTimestampChanged,
    isMAxViewOver,
    video_ads_setting,
    isSpqShown,
    isLive,
    page_id
  ]);

  useEffect(() => {
    if (
      video_ads_setting &&
      videoAdsShowCount >= video_ads_setting?.max_ads_per_video &&
      !isMAxViewOver
    ) {
      setIsMaxViewOver(true);
    }
  }, [videoAdsShowCount, video_ads_setting, isMAxViewOver]);

  // survey effect end
  const onSkipBtnClick = useCallback(() => {
    if (adsInQueue || countdownStart) {
      setAdsInQueue(false);
      setCountdownStart(false);
    }

    if (videoType == VIDEO_TYPE_ADS && playerRef?.current && previous_video_time >= 0) {
      let temp_count = parseInt(videoAdsShowCount) + parseInt(1);
      let currentTime = getCurrentTime();

      if (adsIndex >= 0 && adsIndex < ads_banner_main_data?.length) {
        let next_ads_index = parseInt(adsIndex) + 1;
        setAdsIndex(next_ads_index);
      } else {
        setAdsIndex(0);
      }

      setVideoAdsShowCount(temp_count);
      setLastAdsViewedTimestamp(currentTime);

      console.log('video type set skip click---------------------------', videoType);

      setvideoUrl(file);
      setVideoState((prev) => {
        return { ...prev, isSkipButton: false, playing: true };
      });
      console.group('video type change');
      console.log('main on skip function');
      console.group('video type change');
      setVideoType(VIDEO_TYPE_MAIN);
      try {
        let newData = previous_video_time + 5;
        newData = newData > 0 ? newData : 0;
        setTimeout(() => {
          if (newData > 0) {
            console.log('seeking To', previous_video_time, newData);
            playerRef?.current?.seekTo(newData, 'seconds');
          } else {
            console.log('seeking To', newData);

            playerRef?.current?.seekTo(0, 'seconds');
          }
        }, 1000);
      } catch (error) {
        console.log('error happen');
      }

      //console.log("'count updated " + temp_count);

      onBannerChange();
    }
  }, [
    previous_video_time,
    videoType,
    videoState,
    lastAdsViewedTimestamp,
    videoUrl,
    videoAdsShowCount,
    adsIndex,
    ads_banner_main_data
  ]);
  function filterBannerData() {
    // ////console.log('inside filtern json');
    if (!banner_position) {
      throw new Error(
        'Banner Item Must Have a valid position (eg: top,side-top,bottom,side-bottom)'
      );
    }
    if (!page_name) {
      throw new Error('Banner Item Must Have a valid page_name');
    }

    let temp_top_banner_data = banner_play_data; //bannerUtils.filterJsonByPosition(banner_play_data, banner_position);

    const temp_banner_data = {
      top_banner_floating_data: [],
      top_banner_filler_data: [],
      top_banner_fixed_data: []
    };

    if (temp_top_banner_data?.length > 0) {
      temp_banner_data.top_banner_floating_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FLOATING
      );

      temp_banner_data.top_banner_filler_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FILLER
      );

      if (content_id && content_id != 0) {
        temp_banner_data.top_banner_fixed_data = bannerUtils.filterJsonByTargetType(
          temp_top_banner_data,
          TARGET_TYPE_FIXED
        );
      }

      set_separate_data(temp_banner_data);
    } else {
      bannerUtils.log('no Priority /////////');
    }
    // ////console.log('inside filtern json out');
    setPriorityList(temp_banner_data);
  }

  const removeElemIfCriteriaMatched = (arr = []) => {
    const _index = arr.findIndex(({ max_view_per_session, bal_view_per_user_per_camp }) => {
      return max_view_per_session <= 0 || bal_view_per_user_per_camp <= 0;
    });

    //console.log(arr?.length + 'removedData::' + _index);
    if (_index >= 0) {
      arr.splice(_index, 1);
    }
    return arr;
  };

  function setPriorityList(params_separate_data) {
    let temp_top_banner_playing_index =
      _playing_index_ref.current >= 0 ? _playing_index_ref.current : -1;
    console.log('inside set priority' + temp_top_banner_playing_index);
    temp_creative_id = 0;
    let temp_banner_item = [];
    if (params_separate_data.top_banner_fixed_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_fixed_data);
    } else if (params_separate_data.top_banner_floating_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(
        params_separate_data.top_banner_floating_data
      );
    } else if (params_separate_data.top_banner_filler_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_filler_data);
    } else {
    }

    console.log('<before 0 >' + temp_banner_item?.length);
    if (temp_banner_item && temp_banner_item?.length > 0) {
      /** setting up banner play index start */
      if (temp_top_banner_playing_index == -1) {
        console.log('inside case 1 ');
        _playing_index_ref.current = 0;
        setAdsIndex(0);
      } else if (temp_banner_item.length - 1 == temp_top_banner_playing_index) {
        console.log('inside case 2 ');
        _playing_index_ref.current = 0;
        setAdsIndex(0);
      } else if (temp_banner_item.length == temp_top_banner_playing_index) {
        console.log('inside case 3 ');
        _playing_index_ref.current = 0;
        setAdsIndex(0);
      } else {
        let next_stack = '';
        next_stack = temp_top_banner_playing_index + 1;
        _playing_index_ref.current = temp_top_banner_playing_index + 1;
        console.log(_playing_index_ref.current + 'inside case else ' + next_stack);
        setAdsIndex(next_stack);
      }
      /** setting up banner play index end */

      let previous_item_length = temp_banner_item?.length ?? 0;
      let previous_banner_type = temp_banner_item[_playing_index_ref.current]?.target_type ?? '';
      if (
        temp_banner_item?.length > 0 &&
        temp_banner_item[_playing_index_ref.current]?.target_type != TARGET_TYPE_FILLER
      ) {
        let _temp_banner_item = removeElemIfCriteriaMatched(temp_banner_item);

        temp_banner_item = _temp_banner_item;
      }

      console.log(previous_item_length + '<after1>' + temp_banner_item?.length);

      if (
        previous_banner_type != TARGET_TYPE_FILLER &&
        previous_item_length > 0 &&
        temp_banner_item?.length <= 0
      ) {
        let _separate_data = params_separate_data;
        console.log('<recursion>');

        if (previous_banner_type == TARGET_TYPE_FIXED) {
          console.log('fixed ');
          _separate_data.top_banner_fixed_data = temp_banner_item;
        } else if (previous_banner_type == TARGET_TYPE_FLOATING) {
          console.log('floating ');
          _separate_data.top_banner_floating_data = temp_banner_item;
        } else if (previous_banner_type == TARGET_TYPE_FILLER) {
          console.log('filler ');
          _separate_data.top_banner_filler_data = temp_banner_item;
        }
        _playing_index_ref.current = -1;
        _playing_item_ref.current = [];
        setAdsIndex(-1);
        set_ads_banner_main_data([]);

        dispatch(
          updateCurrentQueue({
            ...banner_queue_data,
            video_banner_data: []
          })
        );

        set_separate_data(_separate_data);
        setPriorityList(_separate_data);
      } else {
        // console.log(
        //   previous_item_length +
        //     '<seting up>' +
        //     temp_banner_item?.length +
        //     ':index:' +
        //     _playing_index_ref.current
        // );
        set_ads_banner_main_data([]);

        _playing_item_ref.current = [];
        dispatch(
          updateCurrentQueue({
            ...banner_queue_data,
            video_banner_data: []
          })
        );

        if (temp_banner_item?.length > 0) {
          _playing_item_ref.current = temp_banner_item;

          console.groupEnd('final setup' + position);
          console.log(_playing_index_ref.current + 'setting to state' + temp_banner_item?.length);
          set_ads_banner_main_data(temp_banner_item);
          dispatch(
            updateCurrentQueue({
              ...banner_queue_data,
              video_banner_data: temp_banner_item[_playing_index_ref.current]
            })
          );
        } else {
          dispatch(
            updateCurrentQueue({
              ...banner_queue_data,
              video_banner_data: []
            })
          );
          setAdsIndex(-1);
          set_ads_banner_main_data([]);
        }
      }
    } else {
    }
    console.log('video ads player', _playing_item_ref.current, _playing_item_ref.current);
  }

  const onBannerChange = (action = 'change') => {
    console.log('banner changed');
    try {
      const temp_session_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA)
        ? JSON.parse(sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA))
        : '';

      const temp_reporting_data = bannerUtils.getBannerReportFormat();
      temp_reporting_data.type = page_name;
      temp_reporting_data.type_id = page_id;
      temp_reporting_data.banner_user = banner_user;
      temp_reporting_data.timestamp_get =
        temp_session_data && temp_session_data.get_timestamp ? temp_session_data.get_timestamp : 0;
      temp_reporting_data.campaign_id = ads_banner_main_data[adsIndex]?.campaign_id ?? '';
      temp_reporting_data.creative_id = ads_banner_main_data[adsIndex]?.items[0].creative_id ?? '';
      temp_reporting_data.position = ads_banner_main_data[adsIndex]?.position ?? '';
      temp_reporting_data.os = platform_name;

      const tempCurrentTime = dayjs(new Date()).subtract(currentTime, 'second');
      temp_reporting_data.start_time = dayjs(tempCurrentTime).format(
        bannerLocalConstant.BANNER_DATE_FORMAT
      );
      temp_reporting_data.end_time = bannerUtils.getCurrentTime();
      temp_reporting_data.duration = currentTime;

      // video_duration = 0;
      if (
        temp_reporting_data &&
        temp_reporting_data?.campaign_id &&
        temp_reporting_data?.creative_id
      ) {
        console.log('update report data', temp_reporting_data);
        dispatch(updateReportData(temp_reporting_data));
      } else {
        console.log('report data:', temp_reporting_data);
      }

      bannerUtils.log('end of func.......................' + JSON.stringify(temp_reporting_data));
    } catch (error) {
      console.log('error in banner' + error);
    }
    if (separate_data.top_banner_fixed_data?.length > 0) {
      TARGET_TYPE_FIXED;
    } else if (separate_data.top_banner_floating_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FLOATING);
    } else if (separate_data.top_banner_filler_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FILLER);
    } else {
      bannerUtils.log('no top banner data found /////////' + JSON.stringify(separate_data));
    }
  };
  const calculateMaxViewPerSession = (type = '') => {
    let temp_banner_data = ads_banner_main_data;
    if (adsIndex >= 0 && temp_banner_data?.length > 0) {
      calculation_condition: if (temp_banner_data[adsIndex]?.target_type == TARGET_TYPE_FILLER) {
        //console.log('filler');
        break calculation_condition;
      } else if (
        temp_banner_data[adsIndex].max_view_per_session &&
        parseInt(temp_banner_data[adsIndex].max_view_per_session) > 0 &&
        temp_banner_data[adsIndex].view_per_day &&
        parseInt(temp_banner_data[adsIndex].view_per_day) > 0
      ) {
        //console.log('cal');
        temp_banner_data[adsIndex].total_view_done_per_day_campaign =
          parseInt(temp_banner_data[adsIndex].total_view_done_per_day_campaign) + 1;
        temp_banner_data[adsIndex].max_view_per_user_campaign =
          parseInt(temp_banner_data[adsIndex].max_view_per_user_campaign) + 1;
        temp_banner_data[adsIndex].view_per_day =
          parseInt(temp_banner_data[adsIndex].view_per_day) - 1;
        temp_banner_data[adsIndex].max_view_per_session =
          parseInt(temp_banner_data[adsIndex].max_view_per_session) - 1;

        //----added for optimization----//
        temp_banner_data[adsIndex].bal_view_per_user_per_camp =
          parseInt(temp_banner_data[adsIndex].bal_view_per_user_per_camp) - 1;
        //----optimization----//
      } else {
        console.log('removing');
        try {
          temp_banner_data.splice(adsIndex, 1);
        } catch (error) {
          console.log(error);
        }
      }

      //////console.log("before" + temp_banner_data.length)
      if (
        temp_banner_data?.length > 0 &&
        temp_banner_data[_playing_index_ref.current].target_type != TARGET_TYPE_FILLER
      ) {
        temp_banner_data = removeElemIfCriteriaMatched(temp_banner_data);
      }

      ////console.log("after" + temp_banner_data.length)

      let temp_separate_data = '';
      temp_separate_data = separate_data;

      switch (type) {
        case TARGET_TYPE_FIXED:
          temp_separate_data.top_banner_fixed_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FILLER:
          temp_separate_data.top_banner_filler_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FLOATING:
          temp_separate_data.top_banner_floating_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        default:
          bannerUtils.log('type null');
          break;
      }

      let temp_local_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
      temp_local_data = temp_local_data ? JSON.parse(temp_local_data) : '';

      // console.log('data sync with local');
      if (
        typeof temp_local_data == 'object' &&
        typeof temp_local_data.global_banner_data == 'object'
      ) {
        switch (position) {
          case bannerLocalConstant.BANNER_POSITION_VIDEO:
            temp_local_data.global_banner_data.video_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          default:
            break;
        }

        if (
          content_id &&
          content_id != 0 &&
          content_ads_data &&
          typeof content_ads_data == 'object'
        ) {
        } else {
          sessionStorage.setItem(
            bannerLocalConstant.GLOBAL_BANNER_DATA,
            JSON.stringify(temp_local_data)
          );
        }
      } else {
        bannerUtils.log('not set on local');
      }

      setPriorityList(temp_separate_data);
      set_separate_data(temp_separate_data);
    } else {
      bannerUtils.log('banner data----------------');
    }
    bannerUtils.log('exit done ');
  };

  function getTimeDifference(from) {
    let now = getCurrentTime(); //todays date
    if (now == from) {
      return 0;
    }
    let duration = dayjs(now).diff(dayjs(from), 'second');
    return duration;
  }

  const adsHandler = (currentTime, ads_data, adsIndex, duration) => {
    handlerCheckCounter += 1;
    if (handlerCheckCounter <= 5 || adsInQueue) {
      return false;
    }
    handlerCheckCounter = 0;
    if (currentTime <= 0) {
      return false;
    }

    let adsItem = adsIndex >= 0 && ads_data?.length > 0 ? ads_data[adsIndex] : {};
    let percentageViewed = '';
    percentageViewed = (currentTime * 100) / duration;

    if (
      videoType == VIDEO_TYPE_MAIN &&
      percentageViewed &&
      percentageViewed >= 0 &&
      adsItem?.ad_start_time &&
      adsItem?.ad_start_time >= 0 &&
      Math.ceil(percentageViewed) >= Math.ceil(adsItem?.ad_start_time)
    ) {
      let temp_data = ads_data;
      temp_data[adsIndex].visited = true;
      set_ads_banner_main_data(temp_data);

      dispatch(
        updateCurrentQueue({
          ...banner_queue_data,
          video_banner_data: temp_data[adsIndex]
        })
      );

      if (videoType == VIDEO_TYPE_MAIN) {
        set_previous_video_time(Math.round(currentTime) >= 0 ? Math.round(currentTime) : 0);
      }
      startAds();
      // setVideoType(VIDEO_TYPE_ADS);
      // setvideoUrl(adsItem?.items[0]?.file);

      // if (adsItem?.isSkipButton && adsItem?.ad_skip_time >= 0) {
      //   setVideoState((prev) => {
      //     return { ...prev, isSkipButton: true };
      //   });
      // }
    }
  };

  useEffect(() => {
    setVideoConatinerSize();
  }, [isLandscape]);

  useEffect(() => {
    const tempVideoDuration = playerRef?.current?.getDuration();
    // console.log('temp duration 1:', videoState, '\n', playerRef?.current?.getDuration());
    setVideoState((prev) => {
      return { ...prev, duration: tempVideoDuration };
    });
    return () => {
      setVideoState((prev) => {
        return { ...prev, duration: 0 };
      });
    };
  }, [videoUrl]);
  const recordActivity = () => {
    let user_action = {};
    user_action['step' + step_counter] = [...progressData.step];
    tracking_data.progress.push(user_action);
    progressData.step = [];
    step_counter += 1;
  };
  const handlePlayPause = useCallback(() => {
    // console.log('play/pause:', videoType, videoState);
    if (videoType != VIDEO_TYPE_SPQ) {
      setVideoState((prev) => {
        return { ...prev, playing: !playing };
      });
    } else {
      toast.info('Video Will Play after attending the Survey');
    }
  }, [videoState, videoType]);

  const handleRewind = useCallback(
    (e) => {
      let nextDuration = '';
      nextDuration = currentTime - 10;
      console.log('rewind', currentTime, duration, nextDuration);
      if (currentTime >= 0 && nextDuration > 0 && nextDuration <= duration) {
        console.log('seeking To', currentTime, duration, nextDuration);
        playerRef.current.seekTo(nextDuration);
      } else {
        console.log('seeking To', currentTime, duration, nextDuration);
        playerRef.current.seekTo(0);
      }
    },
    [currentTime, duration]
  );

  const handleFastForward = useCallback(
    (e) => {
      let nextDuration = '';
      nextDuration = currentTime + 10;
      if (currentTime >= 0 && nextDuration > 0 && nextDuration <= duration) {
        console.log('seeking To', currentTime, duration, nextDuration);
        playerRef.current.seekTo(nextDuration);
      } else {
        console.log('seeking To', currentTime, duration, nextDuration);
        playerRef.current.seekTo(duration);
      }
    },
    [currentTime, duration]
  );

  const handleProgress = (changeState) => {
    prevCountRef.current = changeState.playedSeconds;
    if (isError) {
      // alert("handle progress is error" + JSON.stringify(isError))
      setVideoState((prev) => {
        return { ...prev, isError: false, playing: true };
      });

    }
    // alert("handle progress is error else" + JSON.stringify(isError))

    if (videoType == VIDEO_TYPE_MAIN && playing && controlsRef.current && count > 3) {
      controlsRef.current.style.visibility = 'hidden';
      count = 0;
      setVideoState((prev) => {
        return { ...prev, controlVisibility: false };
      });
    }

    if (
      videoType == VIDEO_TYPE_MAIN &&
      playing &&
      !isError &&
      controlsRef.current &&
      controlsRef.current.style.visibility == 'visible'
    ) {
      count += 1;
    }

    if (bufferCounter > 3) {
      setVideoState((prev) => {
        return { ...prev, isBuffering: false };
      });
      bufferCounter = 0;
    }
    if (isBuffering && !playing) {
      bufferCounter += 1;
    }

    if (!videoState.seeking) {
      setVideoState((prev) => {
        return { ...prev, ...changeState };
      });
    }
    if (
      videoType == VIDEO_TYPE_MAIN &&
      tracking_data.max_view_duration < changeState.playedSeconds / 60
    ) {
      let tempCurrentTime = changeState.playedSeconds / 60;
      tracking_data.max_view_duration = tempCurrentTime.toFixed(DATA_DESIMAL_POINT);
    }

    let progressTrackObj = {
      timestamp: getCurrentTime(),
      progressDetails: JSON.stringify(changeState)
    };

    if (progress_delay == 0) {
      progressData.step.push(progressTrackObj);
      recordActivity();
      progress_delay = 10;
    } else {
      progress_delay -= 1;
    }
  };

  const handleSeekBarChange = (event) => {
    try {
      console.log('seeking To', event.target.value);
      playerRef?.current?.seekTo(event.target.value, 'seconds');
    } catch (error) {
      console.log('error in handle seek change', error);
    }
  };

  const handleSeekMouseDown = useCallback(
    (e) => {
      setVideoState((prev) => {
        return { ...prev, seeking: true };
      });
    },
    [videoState]
  );

  const handleSeekMouseUp = useCallback(
    (e, newValue) => {
      console.log('seek mouse up', { value: e.target });
      setVideoState((prev) => {
        return { ...prev, seeking: false };
      });

      let newData = newValue / 100;
      try {
        setTimeout(() => {
          if (newData >= 0) {
            playerRef?.current?.seekTo(newData, 'seconds');
          } else {
            playerRef?.current?.seekTo(0, 'seconds');
          }
        }, 1000);
      } catch (error) {
        console.log('error happen');
      }
    },
    [videoState]
  );

  const handleDurations = (duration) => {
    console.log('temp duration', duration);
    // setVideoState({ ...videoState, duration: '' });
    setVideoState((prev) => {
      return { ...prev, duration: duration };
    });
  };

  const handleVolumeSeekDown = useCallback(
    (e, newValue) => {
      setVideoState((prev) => {
        return { ...prev, seeking: false, volume: parseFloat(newValue / 100) };
      });
    },
    [videoState]
  );
  const handleVolumeChange = useCallback(
    (newValue) => {
      // console.log(newValue);
      setVideoState((prev) => {
        return {
          ...prev,
          volume: parseFloat(newValue / 100),
          muted: newValue == 0 ? true : false
        };
      });
    },
    [videoState]
  );

  const toggleFullScreen = useCallback(() => {
    console.log('toogle fullscreen ', screenful.isFullscreen, videoState);
    screenful.toggle(playerContainerRef.current);

    try {
      if (fullscreen && isMobile && window && 'orientation' in window.screen) {
        window.screen.orientation.lock('landscape-primary');
      }
    } catch (error) {
      console.log('error in fullscreen change');
    }
  }, [screenful, isMobile, fullscreen, videoState]);

  const handleMouseMove = () => {
    if (controlsRef.current) {
      controlsRef.current.style.visibility = 'visible';
    }
    count = 0;
    if (!controlVisibility) {
      setVideoState((prev) => {
        return { ...prev, controlVisibility: true };
      });
    }
  };

  const hanldeMouseLeave = useCallback(() => {
    if (controlsRef.current && playing) {
      controlsRef.current.style.visibility = 'hidden';
    }
    count = 0;

    if (controlVisibility && playing) {
      setVideoState((prev) => {
        return { ...prev, controlVisibility: false };
      });
    }
  }, [playing, controlVisibility]);

  useEffect(() => {
    if (controlVisibility) {
      setTimeout(() => {
        setVideoState((prev) => {
          return { ...prev, controlVisibility: false };
        });
      }, 6000);
    }
  }, [controlVisibility]);

  const handleDisplayFormat = useCallback(() => {
    setTimeDisplayFormat(timeDisplayFormat == 'normal' ? 'remaining' : 'normal');
  }, [timeDisplayFormat]);

  const parseInput = (input) => {
    const num = Number(input);
    console.log('input', num, input);
    // Check if the input string is a valid number
    if (Number.isNaN(num)) {
      return NaN;
    }

    // Check if the input string contains a decimal point
    // if (input?.includes('.')) {
    return parseFloat(input);
    // } else {
    //   return parseInt(input);
    // }
  };
  const handlePlaybackRate = useCallback(
    (rate) => {
      console.log('playback reate chnage ', rate, playbackRate);
      let newPlaybackRate = Number.isNaN(rate) ? rate : parseInput(rate);
      console.log('playback reate chnage new  ', rate, newPlaybackRate);
      setVideoState((prev) => {
        console.log('prev state', prev);
        return { ...prev, playbackRate: newPlaybackRate };
      });
    },
    [playbackRate]
  );

  const hanldeMute = useCallback(() => {
    setVideoState((prev) => {
      return { ...prev, muted: !prev.muted };
    });
  }, [videoState]);

  const addBookmark = () => {
    const canvas = canvasRef.current;
    canvas.width = 160;
    canvas.height = 90;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(playerRef.current.getInternalPlayer(), 0, 0, canvas.width, canvas.height);
    const dataUri = canvas.toDataURL();
    canvas.width = 0;
    canvas.height = 0;
    const bookmarksCopy = [...bookmarks];
    bookmarksCopy.push({
      time: playerRef.current.getCurrentTime(),
      display: format(playerRef.current.getCurrentTime()),
      image: dataUri
    });
    setBookmarks(bookmarksCopy);
  };

  const onVideoContainerClick = useCallback(
    (e) => {
      handlePlayPause();
      // switch (e.detail) {
      //   case 1:
      //     if (videoPlay) {
      //       setTimeout(() => {
      //         setPlayPauseEffect('pause');
      //       }, 10);
      //       handlePause();
      //       setOverlayClickEffect(!overlayClickEffect);
      //     } else {
      //       setTimeout(() => {
      //         setPlayPauseEffect('play');
      //       }, 10);
      //       handlePlay();
      //       setOverlayClickEffect(true);
      //     }
      //     break;
      //   case 2:
      //     if (isInFullScreen) {
      //       closeFullscreen();
      //     } else {
      //       openFullscreen();
      //     }
      //     break;
      //   // case 3:
      //   //   //console.log("triple click");
      //   //   break;
      //   default:
      //     return;
      // }
      // setVideoControl(!videoControl);
    },
    [videoState]
  );

  const onToogleView = useCallback(() => {
    // setIsBannrExpanded(!isBannrExpanded);
  }, []);

  const onSettingsClick = useCallback(
    (data) => {
      console.log('settings click ' + data);
      setIsSettingsOpen(!isSettingsOpen);
    },
    [isSettingsOpen]
  );
  const onMobileSettingsClick = useCallback(
    (data) => {
      console.log('settings click ' + data);
      setIsMobileSettingsOpen(!isMobileSettingsOpen);
    },
    [isMobileSettingsOpen]
  );

  const onSettingsCloseAreaClick = () => {
    setIsMobileSettingsOpen((prev) => !prev);
    setOpenedSetting('');
  };

  const handleVideoEnd = (e) => {
    tracking_data.end_time = getCurrentTime();
    let temp_previous_time = previous_video_time / 60;
    console.log('video end', previous_video_time, temp_previous_time, videoType, duration);

    if (
      videoType == VIDEO_TYPE_ADS &&
      playerRef?.current &&
      (temp_previous_time >= 0 || temp_previous_time <= duration)
    ) {
      onBannerChange();
      setvideoUrl('');
      let temp_count = parseInt(videoAdsShowCount) + 1;

      let _currentTime = getCurrentTime();
      setVideoAdsShowCount(temp_count);
      setLastAdsViewedTimestamp(_currentTime);
      console.group('video type change');
      console.log('main video end function');
      console.group('video type change');

      if (adsIndex >= 0 && adsIndex < ads_banner_main_data?.length) {
        let next_ads_index = parseInt(adsIndex) + 1;
        setAdsIndex(next_ads_index);
      } else {
        setAdsIndex(0);
      }
      setvideoUrl(file);
      setVideoType(VIDEO_TYPE_MAIN);

      let prev_time = previous_video_time - 5;
      try {
        setTimeout(() => {
          if (prev_time > 0) {
            playerRef?.current?.seekTo(prev_time, 'seconds');
          } else {
            playerRef?.current?.seekTo(0, 'seconds');
          }
        }, 1000);

        setTimeout(() => {
          setVideoState((prev) => {
            return { ...prev, playing: true, isSkipButton: false };
          });
        }, 2000);
        // playerRef?.current?.seekTo(previous_video_time + 5, 'seconds');
      } catch (error) {
        console.log(`error on handle video end :${error}`);
      }
    } else {
      // alert()
      setVideoState((prev) => {
        return { ...prev, playing: false };
      });
    }
  };

  const onBannerClick = (data = [], ind = '') => {
    if (!data || data?.length < 0 || ind < 0) return false;
    let temp_click_report = {
      campaign_id: data[ind]?.campaign_id ? data[ind]?.campaign_id : 0,
      content_type: page_name ? page_name : 'not found',
      content_type_id: content_id ?? 0,
      banner_position: 'video',
      creative_id: temp_creative_id ? temp_creative_id : 0
    };
    dispatch(
      addBannerClickReport(temp_click_report, (response) => {
        console.log('click report added');
      })
    );
    setVideoState((prev) => {
      console.log('prev state', prev);
      return { ...prev, playing: false };
    });
    if (data[ind]?.is_consent && data[ind]?.is_consent == 1) {
      //dispatch actions to set modal open and set the consent text
      toggleConsentModal(true);
      setConsentText(data[ind]?.consent_value);

      return false;
    }
    if (data?.length > 0 && data[ind]?.items[0]?.CTA) {
      //////console.log("banner data click" + data[ind].items[0].CTA)
      switch (data[ind]?.items[0]?.CTA) {
        case 'external_url':
          //////console.log("this is external")
          if (data[ind]?.items[0]?.external_URL) {
            bannerUtils.openNewTab(data[ind]?.items[0].external_URL, _TARGET_BLANK);
          }
          break;
        case 'internal_url':
          //////console.log("this is internal")
          if (data[ind]?.items[0]?.internal_type) {
            let redirectUrl = '';
            if (
              data[ind]?.items[0]?.internal_type_id &&
              data[ind]?.items[0]?.internal_type_id != 0
            ) {
              redirectTo(data[ind]?.items[0]?.internal_type, data[ind]?.items[0]?.internal_type_id);
            } else {
              redirectTo(data[ind]?.items[0]?.internal_type);
            }
          }
          break;
        case 'file_download':
          //////console.log("this is file download")
          if (data[ind]?.items[0]?.CTAupload_file) {
            downloadFromUrl(data[ind]?.items[0]?.CTAupload_file);
          }
          break;
        case 'pdf_open':
          if (data[ind]?.items[0]?.CTAupload_file) {
            openNewTab(data[ind]?.items[0]?.CTAupload_file, _TARGET_BLANK);
          }
          break;
        default:
          ////////console.log("no cta found-----☹☹😲")
          break;
      }
    } else {
      return false;
    }
  };

  const onCtaBtnClick = useCallback(() => {
    console.log('cta btn click in main component ');
    onBannerClick(ads_banner_main_data, adsIndex);
  }, [ads_banner_main_data, adsIndex]);

  const onMobileOpenSettings = useCallback(() => {
    onMobileSettingsClick();
  }, []);
  const onSelectSettings = (type) => {
    setOpenedSetting(type);
  };

  const onPlaybackSpeedSet = (e) => {
    console.log('playback speed ', e.target.value);
    // onMobileOpenSettings();
    setOpenedSetting('');
    onSettingsCloseAreaClick();
    handlePlaybackRate(e.target.value);
  };

  const onBufferStart = () => {
    bufferCounter = 0;
    setVideoState((prev) => {
      return { ...prev, isBuffering: true };
    });
  };
  const onBufferEnd = () => {
    bufferCounter = 0;
    setVideoState((prev) => {
      return { ...prev, isBuffering: false };
    });
  };

  const onQuizStart = useCallback(
    (data) => {
      console.group('video type change');
      console.log('spq on quiz start func');
      console.groupEnd('video type change');
      setAdsInQueue(false);
      setCountdownStart(false);
      setVideoType(VIDEO_TYPE_SPQ);
      setVideoState((prev) => {
        return { ...prev, playing: false };
      });
    },
    [playing, countdownStart, videoType, adsInQueue]
  );

  const onQuizEnd = useCallback(
    (data) => {
      console.group('quiz end log');
      console.log('quiz end in side player', videoState, videoType, previous_video_time);
      dispatch(cleanSpqQueueItem());
      if (spqIndex.current < allSpqData?.length) {
        spqIndex.current = parseInt(spqIndex.current) + 1;
      } else if (spqIndex.current == allSpqData?.length) {
        setSpqNotAllowed(true);
        setAllSpqData([]);
        spqIndex.current = 0;
      } else {
      }
      let newData = previous_video_time + 5;
      console.log('new data :', newData, previous_video_time);
      let delaySeek = '';
      try {
        delaySeek = setTimeout(() => {
          if (newData > 0) {
            console.log('in if', newData);
            playerRef?.current?.seekTo(newData, 'seconds');
          } else {
            console.log('in else ', newData);
            playerRef?.current?.seekTo(0, 'seconds');
          }
        }, 1000);
      } catch (error) {
        console.log('error happen', error);
      } finally {
        console.log('finally executed ');
        setVideoState((prev) => {
          return { ...prev, playing: true };
        });

        setCountdownStart(false);
        setAdsInQueue(false);
        setVideoType(VIDEO_TYPE_MAIN);
        console.log('all done exit  ');
      }
      console.groupEnd('quiz end log');
    },
    [videoState, videoType, previous_video_time, adsInQueue, countdownStart]
  );

  const resetAllWorker = () => {
    let temp_tracking_data = videoAnalyticsRef.current;
    if (temp_tracking_data) {
      temp_tracking_data.play_time = prevCountRef.current;
      temp_tracking_data.end_time = getCurrentTime();
      sendVideoAnalytics(temp_tracking_data);
    }
    setVideoAdsShowCount(0);
    set_banner_play_data([]);
    set_ads_banner_main_data([]);
    setAdsInQueue(false);
    setCountdownStart(false);

    dispatch(cleanSpqQueueItem());
  };
  const onNextBtnClick = useCallback(
    (data) => {
      resetAllWorker();
      if (playlist?.length > 0 && playingIndex >= 0 && playingIndex < playlist?.length) {
        setPlayingIndex((prev) => prev + 1);
        redirectToNextVideo(playlist, playingIndex);
      }
    },
    [playingIndex, playlist, adsInQueue, countdownStart]
  );

  const onPrevBtnClick = useCallback(
    (data) => {
      resetAllWorker();
      if (playlist?.length > 0 && playingIndex > 0 && playingIndex < playlist?.length) {
        setPlayingIndex((prev) => prev - 1);
        // redirectToNextVideo(playlist, playingIndex);
        nav(-1);
      } else {
      }
    },
    [playingIndex, playlist]
  );

  const redirectToNextVideo = (related, index) => {
    console.group('next click');
    bannerUtils.log(related, index);
    if (related?.length > 0) {
      const nextQueueItem = related[index];
      const { type_id, question } = nextQueueItem;
      if (type_id > 0) {
        if (page_name == 'video_archive') {
          bannerUtils.log('redirect to video in');
          redirectTo('ClinicalVideoDetails', type_id, question);
        } else if (page_name == 'gr') {
          console.log('ended gr');
          redirectTo('GrandRoundDetails', cardData.type_id, cardData.title);
        }
        bannerUtils.log('redirect to video else');

        // window.location.reload();
      }
      bannerUtils.log('redirect to video');
    }
    console.log('ended ');
    console.groupEnd('next click');
  };

  const onContainerClick = () => {
    // setVideoState((prev) => {
    //   return { ...prev, controlVisibility: !prev.controlVisibility };
    // });
    console.log('container click', videoState.controlVisibility, isSettingsOpen);
    if (isSettingsOpen) {
      onSettingsCloseAreaClick();
    }
  };

  const onMobileOverlayClick = () => { };

  const onHlsXhrSetup = (xhr, url) => {
    if (url && xhr) {
      const { status } = xhr;
      console.log('HLS object', JSON.stringify(xhr));
      console.log('HLS in:', isLive, xhr, status);
      if (status == 200 && !isLive) {
        console.log('HLS xhr:', xhr, status);
        setVideoState((prev) => {
          return { ...prev, isLive: true };
        });
      } else {
        if (isLive) {
          setVideoState((prev) => {
            return { ...prev, isLive: false };
          });
        }
      }
    }
  };

  const onPlayerError = (e) => {
    // alert('on player error' + JSON.stringify(e));
    if (!playing && e?.name != "NotAllowedError" && e?.method != "play") {
      setVideoState((prev) => {
        return { ...prev, isError: true, playing: false };
      });
    }
  };

  const onVideoPause = (e) => {
    console.log('on video pause');
    setVideoState((prev) => {
      return { ...prev, playing: false };
    });
  };
  const onVideoPlay = (e) => {
    if (playerRef.current.getCurrentTime() < 0) {
      console.log('on video play return', playerRef.current.getCurrentTime());
      return false;
    }
    console.log('on video play', playerLoadedFirstTime, videoStartTime, videoType);
    let videoLoadTime = playerRef && playerRef.current ? playerRef.current.getSecondsLoaded() : 0;
    // if (
    //   !playerLoadedFirstTime &&
    //   videoStartTime > 0 &&
    //   videoType == VIDEO_TYPE_MAIN
    // ) {
    //   try {
    //     console.log('on video play', videoStartTime);
    //     playerRef?.current?.seekTo(videoStartTime, 'seconds');
    //   } catch (error) {
    //     console.log('video seek error ' + error);
    //   }
    // }
    if (!playing) {
      setVideoState((prev) => {
        return { ...prev, playing: true };
      });
    }
    console.log('on video playing', playing);
  };

  const onVideoReady = () => {
    setVideoState((prev) => {
      return { ...prev, controlVisibility: true, playing: true };
    });
    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let readyTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_loaded_on_player',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(readyTrackObj);
    recordActivity();
  };

  const startAds = () => {
    setAdsInQueue(true);
    setCountdownStart(true);
  };

  const handleStart = (e) => {
    // e.preventDefault();
    let tempDuration = duration / 60;
    tracking_data.video_duration = tempDuration.toFixed(DATA_DESIMAL_POINT);
    tracking_data.start_time = getCurrentTime();

    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let startTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_play_started',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(startTrackObj);
    recordActivity();
  };

  const onCountDownEnd = () => {
    console.log('incomming count down end e', countdownStart, adsInQueue, videoType);
    if (countdownStart || adsInQueue) {
      setAdsInQueue(false);
      setCountdownStart(false);
    }
    if (adsInQueue && adsIndex >= 0 && ads_banner_main_data?.length > 0) {
      let adsItem =
        adsIndex >= 0 && ads_banner_main_data?.length > 0 ? ads_banner_main_data[adsIndex] : {};
      setVideoType(VIDEO_TYPE_ADS);
      setvideoUrl(adsItem?.items[0]?.file);

      if (adsItem?.isSkipButton && adsItem?.ad_skip_time >= 0) {
        setVideoState((prev) => {
          return { ...prev, isSkipButton: true };
        });
      }
    } else {
      console.log('incomming count down else', countdownStart, adsInQueue, videoType);
    }
  };

  const handlePlayerSeek = (e) => {
    console.log('seeek change.........||||||||||' + e);

    let tempFrom = currentTime / 60;
    let tempTo = e / 60;

    let seekTrackObj = {
      timestamp: getCurrentTime(),
      from: tempFrom.toFixed(DATA_DESIMAL_POINT),
      to: tempTo.toFixed(DATA_DESIMAL_POINT)
    };

    tracking_data.seekbar_change.push(seekTrackObj);

    recordActivity();
  };
  const onAgreeConsent = () => {
    // alert('agree');
    let data = ads_banner_main_data;
    let ind = adsIndex;
    console.log('data_ind', data, ind);
    if (!data || data?.length < 0 || ind < 0) return false;

    let campaign_id = data[ind]?.campaign_id ? data[ind]?.campaign_id : 0;
    let mobile_primary = userDetails()?.mobile_primary ? userDetails()?.mobile_primary : '';
    let device_details = getClientDeviceDetails(mobile_primary);

    dispatch(
      addBannerConsentClickReport(
        parseInt(campaign_id),
        JSON.stringify(device_details),
        (response) => {
          ////console.log("consent report added")
          toggleConsentModal(false);
        }
      )
    );
    if (data?.length > 0 && data[ind]?.items[0]?.CTA) {
      console.log('banner data click' + data[ind].items[0].CTA);
      switch (data[ind]?.items[0]?.CTA) {
        case 'external_url':
          ////console.log("this is external")
          if (data[ind]?.items[0]?.external_URL) {
            bannerUtils.openNewTab(data[ind]?.items[0].external_URL, _TARGET_BLANK);
          }
          break;
        case 'internal_url':
          ////console.log("this is internal")
          if (data[ind]?.items[0]?.internal_type) {
            let redirectUrl = '';
            if (
              data[ind]?.items[0]?.internal_type_id &&
              data[ind]?.items[0]?.internal_type_id != 0
            ) {
              redirectTo(data[ind]?.items[0]?.internal_type, data[ind]?.items[0]?.internal_type_id);
            } else {
              redirectTo(data[ind]?.items[0]?.internal_type);
            }
          }
          break;
        case 'file_download':
          ////console.log("this is file download")
          if (data[ind]?.items[0]?.CTAupload_file) {
            downloadFromUrl(data[ind]?.items[0]?.CTAupload_file);
          }
          break;
        case 'pdf_open':
          ////console.log("this is pdf open   ")
          if (data[ind]?.items[0]?.CTAupload_file) {
            bannerUtils.openNewTab(data[ind]?.items[0]?.CTAupload_file, _TARGET_BLANK);
            // set_cta_url(data[ind].CTAupload_file);
            // set_cta_target(_TARGET_BLANK)
          }
          break;
        default:
          //////console.log("no cta found-----☹☹😲")
          break;
      }
    } else {
      return false;
    }
  };
  currentTime = playerRef && playerRef.current ? playerRef.current.getCurrentTime() : 0;

  getduration = playerRef && playerRef.current ? playerRef.current.getDuration() : 0;
  getSecondsLoaded = playerRef && playerRef.current ? playerRef.current.getSecondsLoaded() : 0;

  elapsedTime =
    timeDisplayFormat == 'normal' ? format(currentTime) : `-${format(duration - currentTime)}`;

  totalDuration = format(getduration);

  videoDuration = videoState.duration;
  // console.log(videoDuration, 'video type current time:', currentTime);

  return (
    <>
      <div
        className={`${fullscreen ? `clr_player clr_player--full_screen` : `clr_player`} ${isMobile && ' clr_player--mobile'
          }`}
        id="clr_player"
        ref={playerContainerRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={hanldeMouseLeave}
        onClick={onContainerClick}
      >
        <div
          ref={playerAndControl}
          style={{ height: `${aspectVideoContainerSize}px` }}
          className="clr_player__bodyCopm"
        >
          <ReactPlayer
            className="clr_playerVideo"
            width={'100%'}
            height={'100%'}
            ref={playerRef}
            url={videoUrl}
            pip={pip}
            playing={playing}
            controls={false}
            light={light}
            loop={loop}
            playbackRate={playbackRate}
            volume={volume}
            muted={muted}
            onProgress={handleProgress}
            onReady={onVideoReady}
            onBuffer={onBufferStart}
            onBufferEnd={onBufferEnd}
            onEnded={handleVideoEnd}
            onDuration={handleDurations}
            progressInterval={PROGRESS_INTERVAL}
            onPlay={onVideoPlay}
            onPause={onVideoPause}
            onError={onPlayerError}
            onStart={handleStart}
            onSeek={handlePlayerSeek}
            playsinline={true}
          />
          <Controls
            ref={controlsRef}
            isBuffering={isBuffering}
            isError={isError}
            isSeeking={seeking}
            onSeek={handleSeekBarChange}
            onSeekMouseDown={handleSeekMouseDown}
            onSeekMouseUp={handleSeekMouseUp}
            duration={getduration}
            videoLoaded={getSecondsLoaded}
            onRewind={handleRewind}
            onFastForward={handleFastForward}
            onPlayPause={handlePlayPause}
            playing={playing}
            played={played}
            elapsedTime={elapsedTime}
            currentTime={currentTime}
            totalDuration={totalDuration}
            onMute={hanldeMute}
            muted={muted}
            onVolumeChange={handleVolumeChange}
            onVolumeSeekDown={handleVolumeSeekDown}
            onChangeDispayFormat={handleDisplayFormat}
            playbackRate={playbackRate}
            onPlaybackRateChange={handlePlaybackRate}
            onToggleFullScreen={toggleFullScreen}
            volume={volume}
            onContainerClick={onVideoContainerClick}
            isInFullScreen={fullscreen}
            videoHeight={playerAndControl?.current ? playerAndControl?.current?.clientHeight : 0}
            onSettingsClick={onSettingsClick}
            isSettingsOpen={isSettingsOpen}
            isLive={isLive}
            showSkipButton={isSkipButton}
            videoType={videoType}
            onMobileOpenSettings={onMobileOpenSettings}
            title={title}
            deeplink={deeplink}
            adsData={ads_banner_main_data}
            adsIndex={adsIndex}
            onSkipClick={onSkipBtnClick}
            onNextClick={onNextBtnClick}
            onPrevClick={onPrevBtnClick}
            playlist={playlist}
            playingIndex={playingIndex}
            controlsVisibility={controlVisibility}
            handleMouseMove={handleMouseMove}
            page_id={page_id}
            page_name={page_name}
            onQuizStart={onQuizStart}
            onQuizEnd={onQuizEnd}
            onCommingCountEnd={onCountDownEnd}
            incommingCountDown={countdownStart}
            onBannerClick={onCtaBtnClick}
          />
        </div>

        <div className="clr_player__mobile_bottom">
          {/** mobile and floating ads start */}

          {videoType == VIDEO_TYPE_ADS &&
            ads_banner_main_data?.length > 0 &&
            ads_banner_main_data[adsIndex]?.items[0]?.CTA && (
              <CtaCard
                title={ads_banner_main_data[adsIndex]?.items[0]?.CTA_text}
                // description="Lorem ipsum dolor,nesciunt error iste, at saepe pariatur voluptate quis perferendis"
                buttonText={ads_banner_main_data[adsIndex]?.items[0]?.CTA_button}
                onBtnClick={onCtaBtnClick}
              />
            )}
          {/** mobile and floating ads end */}

          <div className="clr_player__floatingAds">
            <InVideoBannerCard
              position={'video-floating'}
              page_name={page_name}
              isShown={videoType == VIDEO_TYPE_MAIN}
            // toogleBannerView={onToogleView}
            />
          </div>

          {/* {aspectVideoContainerSize > 0 && videoType == VIDEO_TYPE_MAIN && ( */}
          {aspectVideoContainerSize > 0 && !isLoading && videoType != VIDEO_TYPE_ADS && (
            <InteractiveSpq
              height={aspectVideoContainerSize}
              onQuizStart={onQuizStart}
              onQuizEnd={onQuizEnd}
            />
          )}
          {/* )} */}
          {title && <Title title={title} />}
        </div>

        {/* translateY: 0 */}
        <div
          className="clr_player__mobile_dropdownCont"
          style={isMobileSettingsOpen ? { transform: 'translateY(0)' } : {}}
        >
          <div
            className="clr_player__mobile_dropdownCont--closeArea"
            onClick={onSettingsCloseAreaClick}
          ></div>
          <div className="clr_player__dropDwon">
            <ul>
              {/* <li className="clr_player__dropDwon__row" onClick={() => onSelectSettings('quality')}>
                <h2 className="clr_player__dropDwon--ttl">
                  <span>Video Quality</span>

                  <div className="clr_player__dropDwon--Option">
                    <label>
                      1080p <span className="clr_player__dropDwon__tag">HD</span>
                    </label>
                  </div>
                </h2>

                <span className="clr_player__dropDwon__row--arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </span>
              </li> */}
              {openedSetting != 'playback' && (
                <li
                  className="clr_player__dropDwon__row"
                  onClick={() => onSelectSettings('playback')}
                >
                  {playbackRate > 0 && (
                    <>
                      <h2 className="clr_player__dropDwon--ttl">
                        <span>Playback Speed</span>

                        <div className="clr_player__dropDwon--Option">
                          <label>{playbackRate}x</label>
                        </div>
                      </h2>

                      <span className="clr_player__dropDwon__row--arrow">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-chevron-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      </span>
                    </>
                  )}
                </li>
              )}
            </ul>

            {openedSetting == 'quality' && (
              <div className="clr_player__dropDwon__row--2">
                <h2
                  className="clr_player__dropDwon--ttl"
                  onClick={() => onSelectSettings('quality')}
                >
                  Playback Quality
                </h2>
                <h2 className="clr_player__dropDwon--ttl">Select Video Quality</h2>
                <div className="d-flex flex-wrap clr_player__dropDwon--OptionCont">
                  <div className="clr_player__dropDwon--Options">
                    {[1080, 720, 360, 240, 'auto'].map((quality) => (
                      <div className="clr_player__dropDwon--Option">
                        <input type="radio" name="quality" value={`${quality}p`} />
                        <label>
                          {quality} <span className="clr_player__dropDwon__tag">p</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {openedSetting == 'playback' && (
              <div className="clr_player__dropDwon__row--2">
                {/* <h2
                  className="clr_player__dropDwon--ttl"
                  onClick={() => onSelectSettings('playback')}
                >
                  Video Quality
                </h2> */}
                <h2 className="clr_player__dropDwon--ttl">Playback Speed{playbackRate}</h2>

                <div className="d-flex flex-wrap clr_player__dropDwon--OptionCont">
                  {[0.5, 1, 1.5, 2].map((rate) => (
                    <div className="clr_player__dropDwon--Options">
                      <div className="clr_player__dropDwon--Option">
                        <input
                          type="radio"
                          name="playbackSpeed"
                          value={rate}
                          checked={rate == playbackRate}
                          onClick={onPlaybackSpeedSet}
                        />
                        <label>{rate}x</label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* below video container start */}
      {/* <VideoOverlayAds page_name={contentType} /> */}
      {/* below video container end */}
      <ConsentModal
        title="Terms & Conditions"
        is_consent_modal={is_consent_modal}
        consent_text={consent_text}
        onHide={() => {
          setVideoState((prev) => {
            return { ...prev, playing: true };
          });
          toggleConsentModal(false);
        }}
        onAgreeConsent={onAgreeConsent}
      />
    </>
  );
};

export default memo(ReactVideoAdsPlayer);
